import download from '@/utils/download.js'

export const toCsv = data =>
  data
    .map(x =>
      x
        .map(y => {
          const str = y == null ? '' : String(y)

          return `"${str.replace(/"/g, '""')}"`
        })
        .join(',')
    )
    .join('\r\n')

export const downloadCsv = (csv, filename) => download(csv, filename, 'text/csv;charset=utf-8;')
